import { ToggleGroup } from '@components'
import { ChartSpline, Image } from 'lucide-solid'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { type ListLayout, useList } from '../state'

export const LayoutSelector = (props: ToggleGroup.RootProps) => {
	const { activeLayout, setActveLayout } = useService(useList)()

	return (
		<ToggleGroup.Root
			value={[activeLayout()]}
			onValueChange={({ value }) => setActveLayout(value[0] as ListLayout)}
			size="sm"
			height="32px"
			{...props}
		>
			<ToggleGroup.Item
				class={css({
					pointerEvents: activeLayout() === 'image' ? 'none' : 'all',
					height: '32px',
					paddingBottom: '2px',
				})}
				value="image"
			>
				<Image />
			</ToggleGroup.Item>
			<ToggleGroup.Item
				class={css({
					pointerEvents: activeLayout() === 'noramlised' ? 'none' : 'all',
					height: '32px',
					paddingBottom: '2px',
				})}
				value="noramlised"
			>
				<ChartSpline />
			</ToggleGroup.Item>
		</ToggleGroup.Root>
	)
}
